import GlassCard from "Developers/JuanBecchio/Components/GlassCard";
import StreetOfRagePic from "../imgs/street-of-rage-4-cover.jpeg";
import DarkSoulsPic from "../imgs/darksouls-wallpaper.jpeg";

const SeccionJuegos = (): JSX.Element => {
  return (
    <div className='inner-section' style={{ backgroundColor: "skyblue" }}>
      <h5 className='mt-4 text-center title-inner-section'>Juegos:</h5>
      <div className='devprofile-extra-inner'>
        <GlassCard
          title={
            <p>
              Uno de mis <b>Beat 'em up</b> favorito
            </p>
          }
          tooltip='Street of Rage 4'
          parallaxImg={StreetOfRagePic}
        />
        <GlassCard
          title={
            <p>
              Mi <b>"reto"</b> favorito
            </p>
          }
          parallaxImg={DarkSoulsPic}
          tooltip='Dark Souls'
        />
      </div>
    </div>
  );
};

export default SeccionJuegos;
